export interface ChangelogEntry {
  version: string;
  date: string;
  title?: string;
  changes: string[];
}

export const changelogEntries: ChangelogEntry[] = [
  {
    version: '0.5.1',
    date: '2026-08-06',
    changes: [
      'Managed PostgreSQL — run a fully managed database next to your services, with backups and storage handled for you'
    ]
  },
  {
    version: '0.4.9',
    date: '2026-08-02',
    changes: [
      'Partiri for VS Code — deploy, manage services and follow your jobs without leaving your editor',
      'Job history is easier to follow, on desktop and on mobile'
    ]
  },
  {
    version: '0.4.5 – 0.4.8',
    date: '2026-07-31',
    changes: [
      'Custom domains — bring your own domain, verify it, and point it at any web service',
      'Secrets management in the dashboard — create, rotate and remove secrets without the CLI',
      'Security updates'
    ]
  },
  {
    version: '0.4.4',
    date: '2026-07-26',
    changes: [
      'Payments are live — top up with card, Klarna, Apple Pay, Google Pay and local payment methods',
      'Resizing or remounting a disk no longer wipes it — your data stays put',
      'Choose how you view your services: compact list or cards',
      'Security updates'
    ]
  },
  {
    version: '0.3.22',
    date: '2026-07-13',
    changes: [
      'Notifications — get told about deploys, failures and account events straight in the dashboard',
      'Attach a custom domain to a web service while you deploy it',
      'Clearer cron job pricing, so you always know the worst-case cost of a run'
    ]
  },
  {
    version: '0.3.15',
    date: '2026-07-05',
    changes: [
      'Background workers — run long-lived processes with no public endpoint'
    ]
  },
  {
    version: '0.3.14',
    date: '2026-07-02',
    changes: [
      'Roadmap page — see which regions are live and which are on the way',
      'Rewritten documentation for storage, cron jobs, MCP and the CLI',
      'Auto top-up is back — never lose a service to an empty balance',
      'Fixes to saved payment methods, service details and log search'
    ]
  },
  {
    version: '0.3.12',
    date: '2026-06-25',
    changes: [
      'Clearer pricing page, with storage and multi-region add-ons broken out'
    ]
  },
  {
    version: '0.3.11',
    date: '2026-06-23',
    changes: [
      'Search your logs by keyword',
      'Run a custom start command for image and registry services',
      'Services now warn you when there are undeployed changes',
      'Easier-to-read timestamps and metrics across logs and job history',
      'Fixes to SSH keys, sign-in errors and the contact form'
    ]
  },
  {
    version: '0.3.6',
    date: '2026-06-11',
    changes: [
      'Cron services show their schedule at a glance',
      'Service settings are locked by default when editing, so nothing changes by accident',
      'Corrected pricing shown for cron jobs and other services',
      'Better mobile experience across the dashboard',
      'Fixes to static website deploys and intermittent connection errors'
    ]
  },
  {
    version: '0.3.0',
    date: '2026-06-05',
    changes: [
      'Billing is live — top up by card, bank transfer or cryptocurrency',
      'Automatic top-ups when your balance runs low',
      'EU VAT details for 0% reverse-charge invoicing',
      'Invoices and transaction history for every top-up and charge'
    ]
  },
  {
    version: '0.2.9',
    date: '2026-05-22',
    changes: [
      'Danish and Finnish added to the supported languages',
      'Fixes across projects, announcements and the dashboard layout'
    ]
  },
  {
    version: '0.2.0',
    date: '2026-05-19',
    changes: [
      'Redesigned dashboard',
      'Pick a region per service and see the cost before you deploy',
      'Roll back to any previous deployment',
      'Sign in to the CLI from your browser'
    ]
  },
  {
    version: '0.1.20',
    date: '2026-04-24',
    changes: [
      'Status page for incidents and planned maintenance',
      'Service announcements shown across the app',
      'Auto-deploy services now show their webhook URL',
      'Fixes to account balance and transaction history'
    ]
  },
  {
    version: '0.1.12',
    date: '2026-04-16',
    changes: [
      'Scheduled jobs — run workloads on a cron schedule',
      'One-off jobs — run batch workloads to completion',
      'Deploy from GitHub and GitLab container registries, alongside Docker Hub, Google Artifact Registry and AWS ECR',
      'Per-minute pricing with a max cost estimate shown before you deploy a job'
    ]
  }
];
